export default __webpack_public_path__ + "static/media/logo-mobile.f8c2d4c5.svg";